import { t } from "@lingui/macro";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { useCallback } from "react";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { ClubStackNavigatorParamList } from "../../../navigators/ClubNavigator";
import { useUnlockAllSlots } from "../../LockSlots/hooks/useUnlockAllSlots";
import { useJoinExistingBooking } from "./useJoinExistingBooking/useJoinExistingBooking";

export const useJoinBookingAndNavigate = (onSuccess?: () => void) => {
  const [unlockSlot] = useUnlockAllSlots();
  const [handleJoinBooking, isJoining] = useJoinExistingBooking();
  const { showToast } = useToast();

  const navigation =
    useNavigation<NavigationProp<ClubStackNavigatorParamList>>();

  const joinBooking = useCallback(
    (bookingId: string) => {
      handleJoinBooking({ bookingId }, () => {
        showToast({
          description: t`Your booking is confirmed`,
          semanticStyle: "success",
          toastId: "member-join-booking-success",
        });
        onSuccess?.();
        navigation.navigate("BookingSummary", {
          slotOrBookingId: bookingId,
          params: {},
        });

        setTimeout(() => {
          unlockSlot();
        }, 10);
      });
    },
    [handleJoinBooking, navigation, onSuccess, showToast, unlockSlot]
  );

  return { joinBooking, isJoining } as const;
};
